import { Search } from '@mui/icons-material';
import { Box, Chip, useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { FilterIcon, PlusHeaderIcon } from '../../../assets/customIcons';
import { getUpdateKey } from '../../../builderPackage/common/commonFunctions';
import { DynamicFormBuilderContainer } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import { FormItemTypes } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import { DesktopTabComponent } from '../../../components/molecules/desktopTabComponent';
import { LOCAL_STORAGE_KEYS } from '../../../constants';
import { setReducerState } from '../../../redux/crudSlice';
import { useAppDispatch } from '../../../store/hooks';
import { getLocalStorageItem } from "../../../utils/storageHelper";
import ContractSaleOrderCancelledTab from '../components/ContractSaleOrderCancelledTab';
import { ContractSaleOrderCatalogueCancelledMobile } from '../components/ContractSaleOrderCatalogueCancelledMobile';
import { ContractSaleOrderCatalogueInvoicedMobile } from '../components/ContractSaleOrderCatalogueInvoicedMobile';
import { ContractSaleOrderCatalogueOpenMobile } from '../components/ContractSaleOrderCatalogueOpenMobile';
import ContractSaleOrderInvoicedTab from '../components/contractSaleOrderInvoicedTab';
import ContractSaleOrderOpentab from '../components/contractSaleOrderOpenTab';
import { GetContractSaleOrderCountAPI } from '../services/apiCall';
import { ContractSaleOrderKeys } from '../services/entity';
var ContractSaleOrder = function () {
    var _getLocalStorageItem, _getLocalStorageItem2;
    var upXS = useMediaQuery(function (theme) { return theme.breakpoints.up("xs"); });
    var downSM = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var IS_MOBILE = upXS && downSM;
    var IdentityId = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.IdentityId;
    console.log('IdentityId', IdentityId);
    var User = (_getLocalStorageItem2 = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.data) === null || _getLocalStorageItem2 === void 0 ? void 0 : _getLocalStorageItem2.Branches[0];
    var listVariants = [{
            Name: "My contract sales order",
            id: IdentityId
        }, {
            Name: 'All contract sales order',
            id: 'all'
        }];
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var handleOnClick = function () {
        navigate('/createContractSaleOrder');
    };
    var openTab = [{
            type: FormItemTypes.Custom,
            name: 'open',
            element: IS_MOBILE ? ContractSaleOrderCatalogueOpenMobile : ContractSaleOrderOpentab,
            columnSize: 12
        }];
    var invoicedTab = [{
            type: FormItemTypes.Custom,
            name: 'invoiced',
            element: IS_MOBILE ? ContractSaleOrderCatalogueInvoicedMobile : ContractSaleOrderInvoicedTab,
            columnSize: 12
        }];
    var cancelledTab = [{
            type: FormItemTypes.Custom,
            name: 'cancelled',
            element: IS_MOBILE ? ContractSaleOrderCatalogueCancelledMobile : ContractSaleOrderCancelledTab,
            columnSize: 12
        }];
    var formData = [{
            type: FormItemTypes.SingleSelect,
            name: 'IdentityId',
            value: 'all',
            options: listVariants,
            valueExpr: 'id',
            displayExpr: 'Name',
            size: 'medium',
            columnSize: 0,
            disableUnderline: true,
            variant: 'standard',
            sx: {
                fontWeight: 'strong',
                fontSize: '50px !important',
                color: '',
                paddingX: 2,
                marginTop: 2
            }
        }, {
            type: FormItemTypes.Box,
            name: '',
            height: '76px',
            padding: '16px 24px',
            gap: '12px',
            bgcolor: 'secondary.100',
            borderTop: '1px solid ',
            borderBottom: '1px solid ',
            borderColor: 'secondary.200',
            columnSize: 12,
            justifyContent: 'space-between',
            display: 'flex',
            elements: [{
                    type: FormItemTypes.Stack,
                    name: 'actions',
                    direction: 'row',
                    alignItems: 'center',
                    columnGap: 0.5,
                    borderRadius: 2,
                    px: 1.25,
                    py: 0.5,
                    border: '1px solid',
                    borderColor: 'secondary.300',
                    bgcolor: 'white',
                    width: '100%',
                    maxWidth: 400,
                    elements: [{
                            type: FormItemTypes.IconButton,
                            name: 'searchButton',
                            columnSize: 0,
                            color: 'secondary',
                            children: /*#__PURE__*/ React.createElement(Search, {
                                color: "secondary"
                            })
                        }, {
                            type: FormItemTypes.TextInput,
                            name: 'search',
                            columnSize: true,
                            variant: 'standard',
                            placeholder: 'Search by VIN, Reg No, Doc No..',
                            InputProps: {
                                disableUnderline: true
                            },
                            valueSetter: function (state, currValue, field) {
                                var _a;
                                return (_a = {},
                                    _a[field.name] = currValue === null || currValue === void 0 ? void 0 : currValue.trim(),
                                    _a);
                            },
                            setFormState: function (formValues, currValue, field) {
                                console.log('formValues', formValues);
                                return {};
                            }
                        }]
                }, {
                    type: FormItemTypes.Box,
                    name: '',
                    justifyContent: 'end',
                    display: 'flex',
                    columnSize: IS_MOBILE ? 2 : 9,
                    gap: IS_MOBILE ? '0px' : '12px',
                    elements: [{
                            type: FormItemTypes.Button,
                            name: '',
                            children: "".concat(!IS_MOBILE ? "Filters" : ''),
                            columnSize: 0,
                            color: 'secondary',
                            variant: 'outlined',
                            sx: {
                                padding: '10px'
                            },
                            startIcon: /*#__PURE__*/ React.createElement(FilterIcon, null),
                            disabled: true
                        }, {
                            type: FormItemTypes.Divider,
                            name: '',
                            variant: 'fullWidth',
                            orientation: 'vertical',
                            columnSize: 0
                        }, {
                            type: FormItemTypes.Button,
                            name: 'Newbtn',
                            children: 'New',
                            columnSize: 0,
                            color: 'primary',
                            variant: 'contained',
                            sx: {
                                paddingX: '15px',
                                paddingY: '10px',
                                display: IS_MOBILE ? 'none' : 'inline-flex'
                            },
                            startIcon: /*#__PURE__*/ React.createElement(PlusHeaderIcon, null),
                            onClick: handleOnClick
                        }]
                }]
        }, {
            type: FormItemTypes.Tabs,
            name: 'Tabs',
            valueExpr: 'id',
            displayExpr: 'Name',
            columnSize: 12,
            panelGridProps: {
                spacing: 0,
                rowGap: 2,
                marginBottom: '100px'
            },
            tabs: [],
            setFieldProps: function (state) { return ({
                type: FormItemTypes.Tabs,
                tabs: [{
                        id: 'open',
                        Name: /*#__PURE__*/ React.createElement(Box, {
                            display: "flex",
                            alignItems: "center"
                        }, /*#__PURE__*/ React.createElement("span", null, "Open"), /*#__PURE__*/ React.createElement(Chip, {
                            label: state === null || state === void 0 ? void 0 : state.Open,
                            color: "primary",
                            variant: "filled",
                            size: "small",
                            sx: {
                                marginLeft: 1
                            }
                        })),
                        elements: openTab
                    }, {
                        id: 'invoiced',
                        Name: /*#__PURE__*/ React.createElement(Box, {
                            display: "flex",
                            alignItems: "center"
                        }, /*#__PURE__*/ React.createElement("span", null, "Invoiced"), /*#__PURE__*/ React.createElement(Chip, {
                            label: state === null || state === void 0 ? void 0 : state.Invoiced,
                            color: "primary",
                            variant: "filled",
                            size: "small",
                            sx: {
                                marginLeft: 1
                            }
                        })),
                        elements: invoicedTab
                    }, {
                        id: 'cancelled',
                        Name: /*#__PURE__*/ React.createElement(Box, {
                            display: "flex",
                            alignItems: "center"
                        }, /*#__PURE__*/ React.createElement("span", null, "Cancelled"), /*#__PURE__*/ React.createElement(Chip, {
                            label: state === null || state === void 0 ? void 0 : state.Cancel,
                            color: "primary",
                            variant: "filled",
                            size: "small",
                            sx: {
                                marginLeft: 1
                            }
                        })),
                        elements: cancelledTab
                    }]
            }); }
        }, IS_MOBILE ? {
            type: FormItemTypes.Box,
            name: '',
            display: 'flex',
            columnSize: 12,
            position: 'fixed',
            bottom: 0,
            right: 0,
            bgcolor: 'white',
            p: 2,
            width: '100%',
            justifyContent: 'end',
            sx: {
                borderTop: '1px solid ',
                borderColor: 'secondary.200',
                gap: '16px'
            },
            elements: [{
                    type: FormItemTypes.Button,
                    name: 'Newbtn',
                    children: 'New',
                    columnSize: 12,
                    fullWidth: true,
                    color: 'primary',
                    variant: 'contained',
                    startIcon: /*#__PURE__*/ React.createElement(PlusHeaderIcon, null),
                    onClick: handleOnClick
                }]
        } : null];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DesktopTabComponent, null), /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        mode: "edit",
        formData: formData,
        getFormAPI: GetContractSaleOrderCountAPI,
        getKey: ContractSaleOrderKeys.GetStatusCount,
        getRequest: {
            OrganizationId: User === null || User === void 0 ? void 0 : User.OrganizationId,
            ParentOrganizationId: User === null || User === void 0 ? void 0 : User.ParentOrganizationId
        },
        onChange: function (e, _ref) {
            var state = _ref.state, field = _ref.field, value = _ref.value;
            if (field && e)
                dispatch(setReducerState({
                    key: getUpdateKey(ContractSaleOrderKeys.Paging),
                    value: true
                }));
        }
    }));
};
export default ContractSaleOrder;
